import React, { useState } from 'react';
import CustomNavbar from '../CustomNavbar';
import ZRWorkAssignmentList from './zrWorkAssignmentList';
import ZRPersonWorkAssigment from './zrPersonWorkAssignment';
import cfg from '../../config';

// Funktion statt Konstante: auf Modulebene wuerde der Rueckfallwert aus
// config.js eingefroren, bevor AppContext die Serverwerte uebernimmt.
const TABS = () => [
  { key: 'einsaetze',  label: '📋 Arbeitseinsätze',  short: 'Einsätze'     },
  { key: 'mitglieder', label: `🔍 ${cfg.memberTermPlural} suchen`,  short: cfg.memberTermPlural },
];

const pillStyle = (active) => ({
  flexShrink: 0,
  padding: '9px 18px',
  borderRadius: 999,
  border: active ? '2px solid #facc15' : '2px solid rgba(255,255,255,0.2)',
  background: active ? '#facc15' : 'rgba(255,255,255,0.06)',
  color: active ? '#111' : 'rgba(255,255,255,0.75)',
  fontWeight: active ? 700 : 500,
  fontSize: 14,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background .15s, color .15s, border-color .15s',
});

const ZRWorkAssignment = () => {
  const [tab, setTab] = useState('einsaetze');

  return (
    <div className="bg-dark min-vh-100 text-white">
      <CustomNavbar />

      <div className="container mt-4 pb-5">
        <header className="mb-4">
          <h1 className="mb-1">Arbeitseinsätze</h1>
          <p className="text-white-50 mb-0">
            Verwaltung und Suche
          </p>
        </header>

        {/* Mobil: scrollbare Pill-Buttons */}
        <div
          className="d-md-none mb-4"
          style={{
            display: 'flex',
            overflowX: 'auto',
            gap: 8,
            paddingBottom: 4,
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {TABS().map(({ key, short }) => (
            <button key={key} onClick={() => setTab(key)} style={pillStyle(tab === key)}>
              {short}
            </button>
          ))}
        </div>

        {/* Desktop: Underline-Tabs */}
        <ul
          className="d-none d-md-flex nav mb-4"
          style={{ borderBottom: '1px solid rgba(255,255,255,0.15)', gap: 4 }}
        >
          {TABS().map(({ key, label }) => {
            const active = tab === key;
            return (
              <li className="nav-item" key={key}>
                <button
                  className="nav-link"
                  onClick={() => setTab(key)}
                  style={{
                    color: active ? '#facc15' : 'rgba(255,255,255,0.6)',
                    background: 'none',
                    border: 'none',
                    borderBottom: active ? '2px solid #facc15' : '2px solid transparent',
                    borderRadius: 0,
                    fontWeight: active ? 700 : 400,
                    padding: '8px 16px',
                    cursor: 'pointer',
                    transition: 'color .15s, border-color .15s',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {label}
                </button>
              </li>
            );
          })}
        </ul>

        {tab === 'einsaetze'  && <ZRWorkAssignmentList />}
        {tab === 'mitglieder' && <ZRPersonWorkAssigment />}
      </div>
    </div>
  );
};

export default ZRWorkAssignment;
